import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthService from './services/auth'

// Dashboard
import Basic from './views/admin/dashboard/Basic.vue'
import Menu from './views/admin/dashboard/Menu.vue'

// Layouts
import LayoutBasic from './views/layouts/LayoutBasic.vue'

import Place from './views/admin/products/Place.vue'
// Cuentas pedro
import Account from './views/admin/account/Account.vue'
import PettyCash from './views/admin/account/PettyCash.vue'
import Transactions from './views/admin/account/Transactions.vue'
import Transaction from './views/admin/account/Transaction.vue'
import Transport from './views/admin/transport/Transport.vue'
import Shipment from './views/admin/transport/Shipment.vue'
import TypeAccount from './views/admin/account/TypeAccount.vue'

import LayoutLogin from './views/layouts/LayoutLogin.vue'
// Users
/* import Users from './views/admin/users/Users.vue'
import Profile from './views/admin/users/Profile.vue' */

// Auth
import Login from './views/auth/Login.vue'
import Register from './views/auth/Register.vue'

import NotFoundPage from './views/errors/404.vue'

// PRODUCTOS de ARTURO
import Products from './views/admin/products/Products.vue'
import Stocks from './views/admin/products/Stocks.vue'
import Kardex from './views/admin/products/Kardex.vue'
import Stock from './views/admin/products/Stock.vue';
import PriceHistory from './views/admin/products/PriceHistory.vue';

// NO TOCAR OCHOA
// eslint-disable-next-line no-unused-vars
import Sale from './views/admin/sale/Sale.vue'
import ListSale from './views/admin/sale/ListSale.vue'
import ChequerSale from './views/admin/sale/ChequerSale.vue'
import Document from './views/admin/sale/Document.vue';
import ViewSale from './views/admin/sale/ViewSale.vue';
// PDFs
import PDFPrueba from './views/admin/pdf/PDFPrueba.vue'
// import print from './views/admin/utils/print.vue'
import Print from './views/admin/pdf/Print.vue'


// MODULO DE PERSONAS
import Client from './views/admin/persons/Client.vue'
import Provider from './views/admin/persons/Provider.vue'
import Employee from './views/admin/persons/Employee.vue'
import Role from './views/admin/persons/Role.vue'
import Permits from './views/admin/persons/Permits.vue'
import RolePermits from './views/admin/persons/RolePermits.vue'

import User from './views/admin/persons/User.vue'
import Salary from './views/admin/persons/Salary.vue'
import Fault from './views/admin/persons/Fault.vue'
import Bank from './views/admin/settings/Bank.vue'
import Purchase from './views/admin/purchase/Purchase.vue';
import ListPurchase from './views/admin/purchase/ListPurchase.vue';
import ViewPurchase from './views/admin/purchase/ViewPurchase';
// CONFIGURACIONES
// Loans
import ShowPaymentsOutgoingLoan from './views/admin/outgoingLoan/ShowPaymentsLoan.vue';
import ListOutgoingLoan from './views/admin/outgoingLoan/ListgoingLoan.vue';
import OutgoingLoan from './views/admin/outgoingLoan/outgoingLoan.vue';

import deliveryIn from './views/admin/cellar/deliveryIn.vue'
import deliveryOut from './views/admin/cellar/deliveryOut.vue'
import delivery from './views/admin/cellar/delivery.vue'
import deliveryReceived from './views/admin/cellar/deliveryReceived.vue'
// NO TOCAR OCHOA
// eslint-disable-next-line no-unused-vars
import ListIncomingLoan from './views/admin/incomingLoan/ListIncomingLoan.vue';
import IncomingLoan from './views/admin/incomingLoan/IncomingLoan.vue';
import ShowPaymentsIncomingLoan from './views/admin/incomingLoan/ShowPaymentsLoan.vue';
import Notification from './views/admin/notifications/Notification.vue';

import Reports from './views/admin/settings/Reports.vue'
// import Factura from './views/admin/pdf/Factura.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/admin",
    component: LayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Dashboard
      {
        path: "dashboard",
        component: Basic
      },
      {
        path: "menu",
        component: Menu,
        name: "menu"
      },
      {
        path: "dashboard/basic",
        component: Basic,
        name: "dashboard"
      },
      {
        path: "productos/localidades",
        component: Place
      },
      {
        /* path: 'account', */
        path: "cuentas",
        component: Account,
        name: "Cuentas"
      },
      {
        path: "cajas",
        component: PettyCash,
        name: "cash"
      },
      {
        path: "cuenta/ver",
        component: Transactions,
        name: "verCuenta",
        props: true
      },
      {
        path: "transacciones",
        component: Transaction
      },
      {
        path: "productos/transporte",
        name: "transport",
        component: Transport
      },
      {
        path: "productos/transporte/envio",
        component: Shipment,
        name: "verEnvio",
        props: true
      },
      {
        path: "cuenta/tipodecuenta",
        component: TypeAccount
      },

      // MODULO DE PRODUCTOS
      // Productos
      {
        path: "products/productos",
        component: Products,
        name: "Productos"
      },
      {
        path: "products/kardex",
        component: Kardex,
        name: "verKardex",
        props: true
      },
      {
        path: "products/stock",
        component: Stock,
        name: "verStock",
        props: true
      },
      // Existencia
      {
        path: "products/ajuste",
        component: Stocks
      },
      {
        path: "products/historial",
        component: PriceHistory
      },
      // PDF de prueba

      {
        path: "pdfprueba",
        component: PDFPrueba
      },

      // MODULO DE VENTAS
      // VENTA
      {
        path: "venta/lista",
        component: ListSale,
        props: true,
        name: "VentaLista"
      },
      {
        path: "venta/nuevo",
        component: Sale
      },
      {
        path: "venta/cobrar",
        component: ChequerSale,
        props: true,
        name: "VentaCobrar"
      },
      // {
      //   path: 'ajuste/permiso/especial',
      //   component: SpecialPermissions
      // },
      {
        path: "venta/ver",
        component: ViewSale
      },
      {
        path: "venta/imprimir",
        component: Print
      },
      {
        path: "venta/documentos",
        component: Document
      },
      {
        path: "ajuste/bancos",
        component: Bank
      },
      // Sales
      {
        path: "compra/nuevo",
        component: Purchase
      },
      {
        path: "compra/lista",
        component: ListPurchase,
        name: "CompraLista"
      },
      {
        path: "compra/ver",
        component: ViewPurchase
      },
      // End sales
      // MODULO DE PERSONAS
      // Cliente
      {
        path: "personas/clientes",
        component: Client
      },
      {
        path: "personas/proveedores",
        component: Provider
      },
      {
        path: "personas/empleados",
        component: Employee
      },
      {
        path: "personas/salarios",
        component: Salary
      },
      {
        path: "personas/faltas",
        component: Fault
      },
      {
        path: "personas/roles",
        component: Role,
        name: "Roles"
      },
      {
        path: "personas/permisos",
        component: Permits,
        props: true,
        name: "Permisos"
      },
      {
        path: "personas/rolpermisos",
        component: RolePermits,
        props: true,
        name: "RolesPermisos"
      },
      {
        path: "personas/usuarios",
        component: User
      },
      //LOANS OUT
      {
        path: "cuentasporpagar/lista",
        component: ListOutgoingLoan
      },
      {
        path: "cuentasporpagar/pagar",
        component: OutgoingLoan
      },
      {
        path: "cuentasporpagar/verpagos",
        component: ShowPaymentsOutgoingLoan
      },
      //LOANS IN
      {
        path: "cuentasporcobrar/lista",
        component: ListIncomingLoan
      },
      {
        path: "cuentasporcobrar/pagar",
        component: IncomingLoan
      },
      {
        path: "cuentasporcobrar/verpagos",
        component: ShowPaymentsIncomingLoan
      },
      {
        path: "bodega/entrada",
        component: deliveryIn,
        name: "deliveryIn"
      },
      {
        path: "bodega/salida",
        component: deliveryOut,
        name: "deliveryOut"
      },
      {
        path: "bodega/entrega",
        component: delivery
      },
      {
        path: "bodega/recibir",
        component: deliveryReceived
      },
      // Notificaciones
      {
        path: "notifications",
        component: Notification
      },
      // Reportes

      {
        path: "reports",
        component: Reports
      },
      {
        path: "impresion",
        component: print
      }
    ]
  },
  // Ruta default --> aquí debe ir el login, pero por el momento va el dashboard
  {
    path: "/",
    component: LayoutLogin,
    children: [
      {
        path: "/",
        component: Login,
        name: "login"
      },
      {
        path: "register",
        component: Register,
        name: "register"
      }
    ]
  },

  //  DEFAULT ROUTE
  { path: "*", component: NotFoundPage }
];

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

// Esta ruta es para autenticar que el usuario este logeado para entrar

router.beforeEach((to, from, next) => {
  //  If the next route is requires user to be Logged IN
  if (to.matched.some(m => m.meta.requiresAuth)) {
    return AuthService.check().then(authenticated => {
      if (!authenticated) {
        return next({ path: '/' })
      }

      return next()
    })
  }

  return next()
})

export default router



// WEBPACK FOOTER //
// ./resources/js/router.js